<template>
<div class="page page_piaoliu" style="height:100vh">
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" :immediate-check="false" @load="getData">
        <div class="list">
            <div class="item" v-for="(item,index) in dataList" :key="item.id">
				<van-image v-if="item.type == 1" :src="imageUrl+item.image" fit="cover" :show-error="false" :show-loading="false" class="tu" @click="goDetail(item)" />
				<div class="" v-if="item.type == 2">
					<div class="audio_wrap">
						<div :class="item.play ? 'audio_btn play' : 'audio_btn'" @click="audioState(item,index)"></div>
						<div class="progressbar">
							<div class="greenbar" :ref="'musicBar'+item.id"></div>
						</div>
						<div class="timetext">{{ item.time ? item.time : '00:00'}}</div>
					</div>
					<audio :ref="'player'+item.id" class="audio" :src="imageUrl+item.audio_url"></audio>
				</div>
				<div class="title slh_s" @click="goDetail(item)">{{ item.title }}</div>
				<div class="bottom">
					<div class="user" @click="goDetail(item)">
						<van-image :src="item.user_thumb ? ($publicData.withHttpStart(item.user_thumb) ? item.user_thumb : imageUrl+item.user_thumb) : $publicData.defaultTouxiang " fit="cover" :show-error="false" :show-loading="false" class="thumb" />
						<div class="name">{{ item.user_nickname ? item.user_nickname : '' }}</div>
					</div>
					<div class="like" @click="likeFun(item)">
						<img :src=" item.is_like ? publicPath+'statics/images/icon_liked_red.png' : publicPath+'statics/images/icon_like.png'" alt="" class="icon">
						<span :class="item.is_like ? 'nums liked' : 'nums'">{{ item.like_nums }}</span>
					</div>
				</div>
            </div>
        </div>
    </van-list>
    <!-- 发布按钮 -->
    <div class="post" @click="toPublish">
        <img :src="publicPath+'statics/images/icon_fabu.png'" alt="" class="">
    </div>
</div>
</template>

<script>
import router from '../../../.././router'
import {
    LOGOUT,
    LOGIN
} from '../../../.././vuex/mutation_types'
import Vue from "vue";
import Bridge from "../../../.././vuex/bridge.js";

Vue.prototype.$bridge = Bridge;
var userAgent = navigator.userAgent;

export default {
    name: 'tohistory-index',
    data() {
        return {
			imageUrl: this.$publicData.uploadImage,
            publicPath: process.env.BASE_URL,
            token: '',
            pages: {
                page: 1,
                size: 10
            },
            loading: true,
            finished: false,
			dataList: [],
			gap: 5,
			yuDataList: []
        }
    },
    created: function () {
        //根据userAgent判断是否在iOSAndroid客户端中，隐藏原生导航栏
        var that = this
        if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
            var params = {
                data: {
                    'naviTitle': '书写记忆让爱漂流',
                    'rightStyle': 'share'
                }
            };
            this.$bridge.callhandler("sdjy://navigation/style", params, (data) => {});
            //获取用户信息
            var memberParams = {
                data: {
                    notCallLogin: 1,
                },
            };
            this.$bridge.callhandler("sdjy://member/memberInfo", memberParams,
                (data) => {
                    if (data.code == 200) {
                        this.token = data.result.token;
                    } else {
                        this.token = "";
                    }
                }
            );
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler(
                "sdjy://common/refreshPage",
                (data, responseCallback) => {
                    // alert(JSON.stringify(data));
                    responseCallback('');
                }
            );
            //注册方法，右侧点击分享
            this.$bridge.registerhandler('sdjy://common/rightButtonAction', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                console.log('sdjy://common/rightButtonAction')
                const url = location.href.split('#')[0];
                var params = {
                    data: {
                        title: '书写记忆让爱漂流',
                        detail: '过往记忆历历在目，书写是对历史最好的证明！\n每次书写，都是在寻找记忆和温度……',
                        url: url,
                        platFormType:'',
                        image: that.$publicData.shareImgPath + 'piaoliuping.jpg'
                    },
                };
                this.$bridge.callhandler('sdjy://public/share', params, (data) => {

                })

            })
        } else {
            this.token = this.$store.getters.token;
            this.getShareData()
        }
        this.getData()

    },
    mounted: function () {
		
	},
    methods: {
        // 获取列表
        getData() {
            var params = {
                page: this.pages.page,
                size: this.pages.size,
                type: 0 // 0所有列表,1我的列表
            }
            if (this.token) {
                params.token = this.token
            }
            this.$api.history.lovedriftList(params).then(res => {
                if (res.code == 200) {
                    var list = res.result.list
                    if (list.length != 0) {
                        for (var i in list) {
							list[i].play = false // 播放标识
                            if (list[i].thumb) {
                                var images = list[i].thumb
								list[i].image = images.split(',')[0]
								list[i].type = 1 // 1 显示图片
                            }else if(list[i].thumb && list[i].audio_url){
								list[i].type = 1 // 1 显示图片
							}else if(list[i].audio_url){
								list[i].type = 2 // 2 显示音频
							}
							this.dataList.push(list[i])
						}
                        this.loading = false
						this.pages.page++
						// console.log('列表====',this.dataList)
						// 页面渲染完, 再加载waterFull方法
						this.$nextTick(()=>{
							this.waterFull(document.getElementsByClassName('item'))
						})						
                    } else {
                        this.finished = true
                    }
                } else {
                    this.finished = true
                }
				
            })
		},
		doSort(index, list){
			var that = this
			that.dataList.push(list[index])
			if(index < list.length){
				this.$nextTick(() => {
					setTimeout(() => {
						that.doSort(index+1, list);	
					}, 400);
					// that.waterFull(document.getElementsByClassName('item'))
				})
			}
		},
        // 漂流详情
        goDetail(item) {
            if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
                var url = this.$publicData.clientUrl + "/adrift/detail?drift_id=" + item.id
                var memberParams = {
                    data: {},
                };
                this.$bridge.callhandler("sdjy://member/memberInfo", memberParams,
                    (data) => {
                        if (data.code == 200) {
                            var params = {
                                data: {
                                    url: url
                                },
                            };
                            this.$bridge.callhandler(
                                "sdjy://public/openNewWebView",
                                params,
                                (data) => {}
                            );
                        }
                    }
                );
            } else {
                this.$router.push({
                    path: '/adrift/detail',
                    query: {
                        drift_id: item.id
                    }
                })
            }
        },
        // 发布漂流信息
        toPublish() {
            if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
                var url = this.$publicData.clientUrl + "/adrift/publish"
                var memberParams = {
                    data: {},
                };
                this.$bridge.callhandler("sdjy://member/memberInfo", memberParams,
                    (data) => {
                        if (data.code == 200) {
                            var params = {
                                data: {
                                    url: url
                                },
                            };
                            this.$bridge.callhandler(
                                "sdjy://public/openNewWebView",
                                params,
                                (data) => {}
                            );
                        }
                    }
                );

            } else {
                if (!this.token) {
                    localStorage.setItem('redirect', this.$router.currentRoute.fullPath)
                    this.$router.push({
                        path: '/login',
                    })
                    return
                } else {
                    this.$router.push({
                        path: '/adrift/publish'
                    })
                }
            }
            localStorage.removeItem('selectPoi')
        },
        // 点赞
        likeFun(item) {
            if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
                var url = this.$publicData.clientUrl + "/adrift/publish"
                var memberParams = {
                    data: {},
                };
                this.$bridge.callhandler("sdjy://member/memberInfo", memberParams,
                    (data) => {
                        if (data.code == 200) {
                            this.token = data.result.token;
                            this.likeAction(item)
                        }
                    }
                );

            } else {
                this.likeAction(item)
            }
        },
        likeAction(item) {
            var is_like = item.is_like
            var params = {
                token: this.token,
                drift_id: item.id
            }
            this.$api.history.lovedriftLike(params).then(res => {
                if (res.code == 200) {
                    for (var i in this.dataList) {
                        if (this.dataList[i].id == item.id) {
                            if (is_like == 0) {
                                this.$toast('点赞成功')
                                this.dataList[i].is_like = 1
                                this.dataList[i].like_nums++;
                            } else {
                                this.$toast('取消点赞')
                                this.dataList[i].is_like = 0
                                this.dataList[i].like_nums--;
                            }
                        }
                    }
                }
            })
        },
        // 瀑布流  items为传入的dom
		waterFull(item){
			var iPinW = $(item).eq( 0 ).width(); // 一个块框pin的宽
			console.log('宽度',iPinW)
			var num = 2 // 列数, 这里写死了两列(可以自定义)
			var pinHArr = []; // 用于存储 每列中的所有块框相加的高度。
			var totalHeight = null // 总高度 用于position:absolute 造成的塌陷
			$(item).each(function(index,value){
				var pinH = $(item).eq( index ).height();
				if( index < num ){
					pinHArr[ index ] = pinH; // 第一行中的num个块框pin 先添加进数组pinHArr
					console.log('前两个===',pinH)
					if(index == 0){
						// $(value).addClass('left')
						$( value ).css({
							'position': 'absolute',
							'top': 0 ,
							'left': '.53rem'
						});
					}else{
						// $(value).addClass('right')
						$( value ).css({
							'position': 'absolute',
							'top': 0 ,
							'right': '.53rem'
						});
					}
				}else{
					var minH = Math.min.apply( null, pinHArr );// 数组pinHArr中的最小值minH
					// console.log('最小高度====',minH)
					var minHIndex = $.inArray( minH, pinHArr );
					// console.log('最小高度的索引值',minHIndex,pinHArr)
					$( value ).css({
						'position': 'absolute',
						'top': minH ,
						'left': $(item).eq( minHIndex ).position().left
					});
					// console.log('$(item).eq( minHIndex ).position().left',$(item).eq( minHIndex ).position().left)
					if($(item).eq( minHIndex ).position().left > 0){
						$(value).addClass('right')
					}else{
						$(value).addClass('left')
					}
					// console.log('left',$(item).eq( minHIndex ).position())
					// console.log('高度数组',pinHArr)
					// console.log('总高度', totalHeight)
					// 数组 最小高元素的高 + 添加上的aPin[i]块框高
					pinHArr[ minHIndex ] += $(item).eq( index ).height() ;//更新添加了块框后的列高
					// 数据的总高度, 即拿最高一列的值
					totalHeight = Math.max.apply( null, pinHArr )
					$('.list').css({
						'height': totalHeight + 40
					})
				}
			})
		},
		// 点击播放暂停按钮时间
		audioState(item,index) {
			var that = this
			item.play = !item.play // 更改播放暂停按钮状态
			var music = that.$refs['player'+item.id][0] // 音频所在对象
			var musicBar = that.$refs['musicBar'+item.id][0] // 进度条所在对象
			console.log('获取dom',music)
			if (item.play) {
				music.play() // 播放音乐
				var cTime = '00:00'
				music.addEventListener('timeupdate', () => {
					const musicTime = music.duration // 获得音频时长
					const stopTime = music.currentTime // 获得已播放的音频时长
					musicBar.style.width = `${(stopTime / musicTime) * 100}%` // 计算进度条所在比例宽度
					const branch = Math.floor(stopTime / 60) // 计算已播放的音频分钟
					const second = Math.floor(stopTime % 60) // 计算已播放的音频秒
					if (branch < 10 && second < 10) { // 四种情况判断显示音频以播放时间
						cTime = `0${branch}:0${second}`
					} else if (branch < 10) {
						cTime = `0${branch}:${second}`
					} else if (second < 10) {
						cTime = `${branch}:0${second}`
					} else {
						cTime = `${branch}:${second}`
					}
					item.time = cTime
					that.$set(this.dataList,index,item)
				})
			} else {
				music.pause() // 暂停音乐
			}
			that.$set(this.dataList,index,item)
			
		},
		// 当前播放时长
		cuurentTime(music,musicBar){
			var cTime = '00:00'
			music.addEventListener('timeupdate', () => {
				const musicTime = music.duration // 获得音频时长
				const stopTime = music.currentTime // 获得已播放的音频时长
				musicBar.style.width = `${(stopTime / musicTime) * 100}%` // 计算进度条所在比例宽度
                const branch = Math.floor(stopTime / 60) // 计算已播放的音频分钟
                const second = Math.floor(stopTime % 60) // 计算已播放的音频秒
                if (branch < 10 && second < 10) { // 四种情况判断显示音频以播放时间
                    cTime = `0${branch}:0${second}`
                } else if (branch < 10) {
                    cTime = `0${branch}:${second}`
                } else if (second < 10) {
                    cTime = `${branch}:0${second}`
                } else {
                    cTime = `${branch}:${second}`
				}
				console.log('播放时长',cTime)
			})
			
		},
		// 音频的总时长
		endTime(music){
			var dTime = '00:00'
			const musicTime = music.duration // 获得音频时长
			const branch = Math.floor(musicTime / 60) // 计算音频分钟
			const second = Math.ceil(musicTime % 60) // 计算音频秒
			if (branch < 10 && second < 10) { // 四种情况判断音频总时间
				this.dTime = `0${branch}:0${second}`
			} else if (branch < 10) {
				this.dTime = `0${branch}:${second}`
			} else if (second < 10) {
				this.dTime = `${branch}:0${second}`
			} else {
				this.dTime = `${branch}:${second}`
			}
			console.log('结束时长',dTime)
		},
        // 获取分享参数 -- 用于配微信分享
        getShareData() {
            const url = location.href.split('#')[0];
            console.log('url', url)
            this.$api.index.commonShare({
                url: url
            }).then(res => {
                if (res.code == 200) {
                    this.shareConfig = res.result
                    // console.log('this.shareConfig', this.shareConfig)
                    // console.log('this.$route', this.$route)
                    this.shareFun()
                }
            })
        },
        // 分享
        shareFun() {
            var that = this
            wx.config({
                debug: that.shareConfig.debug,
                beta: that.shareConfig.beta,
                jsApiList: that.shareConfig.jsApiList,
                appId: that.shareConfig.appId,
                nonceStr: that.shareConfig.nonceStr, // 随机串
                timestamp: parseInt(that.shareConfig.timestamp), // 时间戳
                signature: that.shareConfig.signature // 签名
            });
            // 分享
            wx.ready(function () {
                const url = location.href.split('#')[0];
                var shareData = {
                    title: '书写记忆让爱漂流', // 分享标题
                    desc: '过往记忆历历在目，书写是对历史最好的证明！\n每次书写，都是在寻找记忆和温度……', // 分享描述
                    link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: that.$publicData.shareImgPath + 'lishijiyi.jpg', // 分享图标
                    success: function () {
                        // 用户确认分享后执行的回调函数
                        // alert('成功')
                    },
                    cancel: function (e) {
                        // alert(e)
                        // 用户取消分享后执行的回调函数
                    }
                }
                wx.updateAppMessageShareData(shareData);
                wx.updateTimelineShareData(shareData);
            });
        },
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
/* 瀑布流 */
/* .page_piaoliu{
	padding: 0;
}
.page_piaoliu .list{
	display: block;
	height: 100vh;
}
.page_piaoliu .list .item{
	position: absolute;
}
.page_piaoliu .list .item.left{
	left: .53rem !important;
} */
</style>
